import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import AdminService from "../../../../service/AdminService";
import { FilterMatchMode } from "primereact/api";
import { formatDate } from "../../../../utilities/formatDate";

const PaidSubscriptions = () => {
  const [loading, setLoading] = useState(false);
  const [paidSubscriptionPaypal, setPaidSubscriptionPaypal] = useState([]);
  const [paidSubscriptionVoucher, setPaidSubscriptionVoucher] = useState([]);
  const [paidSubscriptionWallet, setPaidSubscriptionWallet] = useState([]);

  const adminService = new AdminService();
  const toast = useRef(null);

  const changeTypePaymentPlan = (value) => {
    if (value === "FIRST") return localeText("initialSub");
    if (value === "RENEW") return localeText("annualRenewal");
    if (value === "TRIAL") return localeText("test");
  };

  const filters2 = {
    title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "user.username": { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  async function fetchData(cancel, paymentmethodid) {
    try {
      setLoading(true);
      const res = await adminService.getPaidSubscriptions(
        localStorage.getItem("__extraconomy_token"),
        paymentmethodid
      );
      console.log(res);
      if (cancel) return;

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
        return false;
      } else {
        setLoading(false);
        return res.result;
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoading(false);
      console.log(e);
    }
  }

  useEffect(() => {
    let cancel = false;

    (async () => {
      const paypalSubscription = await fetchData(cancel, 1);
      const voucherSubscription = await fetchData(cancel, 2);
      const walletSubcscription = await fetchData(cancel, 4);

      if (paypalSubscription) setPaidSubscriptionPaypal(paypalSubscription);
      if (voucherSubscription) setPaidSubscriptionVoucher(voucherSubscription);
      if (walletSubcscription) setPaidSubscriptionWallet(walletSubcscription);
    })();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dataTable = (data) => (
    <DataTable
      className="mt-4 mb-6 p-datatable-customers"
      value={data}
      paginator
      responsiveLayout="scroll"
      loading={loading}
      dataKey="id"
      filters={filters2}
      filterDisplay="row"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate={localeText("showingFirstToLast")}
      rows={10}
      rowsPerPageOptions={[10, 20, 50]}
    >
      <Column
        header={localeText("username")}
        field="user.username"
        filter
        filterPlaceholder={localeText("searchByUsername")}
        filters={filters2}
        filterDisplay="row"
        sortable
        style={{ width: "25%" }}
      />
      <Column
        header={localeText("name")}
        field="user.firstname"
        filter
        filterPlaceholder={localeText("searchByName")}
        filters={filters2}
        filterDisplay="row"
        sortable
        style={{ width: "25%" }}
      />
      <Column
        header={localeText("surname")}
        field="user.surname"
        sortable
        style={{ width: "25%" }}
      />
      <Column
        header={localeText("date")}
        body={(subscription) => formatDate(subscription.datePayment)}
        sortable
        style={{ width: "25%" }}
      />
      <Column
        header={localeText("plan")}
        field="plan.description"
        sortable
        style={{ width: "25%" }}
      />
      <Column header={localeText("amount")} field="amountPaid" sortable style={{ width: "25%" }} />
      <Column
        header={localeText("paymentMethod")}
        field="paymentMethod.description"
        sortable
        style={{ width: "25%" }}
      />
      <Column
        header={localeText("type")}
        body={(subscription) => changeTypePaymentPlan(subscription.typePaymentPlan)}
        sortable
        style={{ width: "25%" }}
      />
    </DataTable>
  );

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} />

      <h3 className="my-4">{localeText("products")}</h3>
      <hr />
      <TabView>
        <TabPanel header="Paypal">{dataTable(paidSubscriptionPaypal)}</TabPanel>
        <TabPanel header="Voucher">{dataTable(paidSubscriptionVoucher)}</TabPanel>
        <TabPanel header={localeText("wallet")}>{dataTable(paidSubscriptionWallet)}</TabPanel>
      </TabView>
    </div>
  );
};

export default PaidSubscriptions;
